<div class="component">
  <div class="header">Weryfikacja adresu e-mail</div>

  <ng-container *ngIf="!authStore.userInfo?.email_verified; else verified">
    <p class="info-text">
      Wejdź na skrzynkę <b>{{ authStore.userInfo?.email }}</b> i kliknij w link aktywacyjny, bądź wpisz poniżej kod
      weryfikacyjny.
    </p>

    <form [formGroup]="form" (ngSubmit)="verifyEmail()" fxLayout="column" fxLayoutAlign="start stretch">
      <mat-form-field appearance="outline">
        <mat-label>Kod weryfikacyjny</mat-label>
        <input
          matInput
          id="verification-code"
          type="text"
          placeholder="XXX-XXX"
          [formControl]="form.verificationState"
          (input)="errors = []"
          mask="000-000"
          pattern="\d{6}"
          appGtmFormEvent
          [eventField]="'verificationCode'"
          [eventForm]="formName"
        />

        <mat-error *ngFor="let error of errors" class="error-message status-error">
          {{ errorMessages[error] }}
        </mat-error>
        <mat-error *ngIf="form.verificationState.errors?.required"> Wpisz kod weryfikacyjny</mat-error>
      </mat-form-field>

      <div *ngIf="verificationCodeResent" class="ok-info">Kod weryfikacyjny został wysłany ponownie.</div>

      <div *ngIf="emailAlreadyConfirmed" class="error-message status-error">
        Twoje konto zostało juz potwierdzone, przejdź do strony logowania.
      </div>

      <div class="troubleshoot">
        <b>Pomoc</b>

        <ul class="pl-14">
          <li>
            Nie możesz znaleźć wiadomości lub kod weryfikacyjny stracił ważność?<br />
            Sprawdź SPAM lub <a (click)="resendVerificationEmail()">wyślij ponownie</a>.
          </li>

          <li>
            Podałeś/aś nieprawidłowy adres e-mail?<br />
            <a (click)="discontinueEmailVerification('auth/register')">Załóż nowe konto</a> lub
            <a (click)="discontinueEmailVerification()">zaloguj się na inne konto</a>.
          </li>
        </ul>
      </div>

      <div class="actions" fxLayout="column">
        <app-new-loader-button
          (buttonClick)="verifyEmail()"
          [loading]="loading"
          class="auth-button"
          id="code-confirmation"
          [customType]="LoaderButtonType.RAISED"
          color="accent"
        >
          Dalej
        </app-new-loader-button>
      </div>
    </form>
  </ng-container>

  <ng-template #verified>
    <div>
      <p class="completed">
        Gratulacje! Adres e-mail: <b>{{ authStore.userInfo?.email }}</b> został potwierdzony. Możesz teraz przejść do
        serwisu.
      </p>

      <app-new-loader-button
        [customType]="LoaderButtonType.RAISED"
        color="accent" class="auth-button" (buttonClick)="goToApp()">
        Przejdź do serwisu
      </app-new-loader-button>
    </div>
  </ng-template>
</div>
